export const B2C_TEXTS = {
    BALANCE_TEXT: "Balance: ₹{0}",
    LOW_BALANCE_TEXT: "Balance: ₹{0} (Low)",
};
